// extracted by mini-css-extract-plugin
export default {"table_header":"vendor-vip-list_table_header__i9Sbq","table_td":"vendor-vip-list_table_td__s7izW"};